import { api } from "../services/axios";

const GetAllwithMacroStepsAPI = async (serviceId: string) => {
    try {
        var result = await api.get(`TimeEntry/GetAllwithMacroSteps/${serviceId}`);
        var response = result.data;
        return response;

    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllwithMacroStepsByProjectAPI = async (payload: any) => {
    try {
        var result = await api.post(`TimeEntry/GetAllwithMacroStepsByProject`, payload);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetByStaffwithMacroStepsAPI = async (serviceId: string, staffName: string,) => {
    try {
        var result = await api.get(`TimeEntry/GetByStaffwithMacroSteps/${serviceId}/${staffName}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const UpdateHoursAPI = async (data: any) => {
    try {
        var result = await api.post(`TimeEntry/UpdateHours`, data);
        var response = result.data;
        return response;

    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UploadTimeEntryAPI = async (file: FormData) => {
    try {
        debugger
        var result = await api.post(`/TimeEntry/UploadExcelTimeEntry`, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteTimeEntriesMassiveAPI = async (serviceId: string, staffIds: string[]) => {
    try {
        var result = await api.post(`/TimeEntry/DeleteTimeEntriesMassive`, { serviceId, staffIds });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


export { GetAllwithMacroStepsAPI, UpdateHoursAPI, GetAllwithMacroStepsByProjectAPI, GetByStaffwithMacroStepsAPI, UploadTimeEntryAPI, DeleteTimeEntriesMassiveAPI };